import { ogImageMeta } from "@/lib/og-images";
import { createFileRoute } from "@tanstack/react-router";
import { AgentDocs } from "@/components/agent-docs";
import { SITE } from "@/lib/site-content";

const TITLE = "For agents · Machine-readable API, MCP & markdown | Vibing Company";
const DESC =
  "An open, unauthenticated toolkit for LLMs: llms.txt, a CORS-open JSON API over 2,000+ curated vibe-coding resources, markdown twins of every page, and a public MCP server.";

export const Route = createFileRoute("/for-agents")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: "For agents — the Vibing Company toolkit" },
      ...ogImageMeta("for-agents", "Share card: built for agents"),
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://vibing.inc/for-agents" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
      { rel: "canonical", href: "https://vibing.inc/docs" },
      { rel: "alternate", type: "text/plain", href: "https://vibing.inc/llms.txt" },
      {
        rel: "service-desc",
        type: "application/json",
        href: "https://vibing.inc/api/public/openapi.json",
      },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebAPI",
          name: "the Vibing Company public API",
          description: DESC,
          documentation: "https://vibing.inc/docs",
          termsOfService: "https://vibing.inc/terms",
          provider: { "@type": "Organization", name: SITE.name, url: SITE.url },
          url: "https://vibing.inc/api/public/openapi.json",
        }),
      },
    ],
  }),
  component: () => <AgentDocs />,
});
